export const NOTIFICATION_TYPE = {
  Success: `success`,
  Error: `error`,
} as const;
const _NOTIFICATION_TYPE_VALUE = Object.values(NOTIFICATION_TYPE);
type NotificationType = typeof _NOTIFICATION_TYPE_VALUE[number];

export interface Notification {
  id: string
  type: NotificationType
  message: string
}

const notifications = ref<Notification[]>([]);

function notifySuccess(message: string) {
  notifications.value.push({
    id: useId(),
    type: NOTIFICATION_TYPE.Success,
    message,
  });
}

function notifyError(message: string) {
  notifications.value.push({
    id: useId(),
    type: NOTIFICATION_TYPE.Error,
    message,
  });
}

const readOnlyNotifications = computed(() => notifications.value);

function remove(id: string) {
  notifications.value = notifications.value.filter(n => n.id !== id);
}

function reset() {
  notifications.value = [];
}

export function useNotifications() {
  return {
    notify: notifySuccess,
    notifySuccess,
    notifyError,
    remove,
    notifications: readOnlyNotifications,
    reset,
  };
}
